import { F0Box } from '@factorialco/f0-react'
import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { ChartLine, MoneyBag } from '@factorialco/f0-react/icons/app'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import i18n from 'modules/core/lib/i18n'
import { Navigate } from 'react-router-dom'
import { AiSettingsRootPageDocument } from 'generated/resources/graphql'
import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { data, loading } = useQuery(AiSettingsRootPageDocument, {
    variables: { companyId: company.id },
  })

  if (loading) {
    return <Loading />
  }

  const employeeCapEnabled = data?.features?.featuresConnection?.nodes[0]?.enabled ?? false

  if (!employeeCapEnabled) {
    return <Navigate to={navigation.settings.fullPath()} replace />
  }

  const creditsPath = navigation.settings.ai.credits.fullPath()
  const usagePath = navigation.settings.ai.usage.fullPath()
  const activeTab: 'credits' | 'usage' = pathname.startsWith(usagePath) ? 'usage' : 'credits'

  return (
    <ResponsivePage.Body variant="fullscreen">
      <F0Box
        display="flex"
        width="full"
        gap="2xl"
        borderTop="default"
        borderColor="secondary"
        height="full"
      >
        <F0Box
          maxWidth="80"
          paddingTop="md"
          height="full"
          borderRight="default"
          borderColor="secondary"
        >
          <F0TableOfContent
            activeItem={activeTab}
            className="h-full"
            items={[
              {
                id: 'credits',
                label: i18n.t('ai.settings.tabs.credits'),
                icon: MoneyBag,
                onClick: () => navigate(creditsPath),
              },
              {
                id: 'usage',
                label: i18n.t('ai.settings.tabs.usage'),
                icon: ChartLine,
                onClick: () => navigate(usagePath),
              },
            ]}
          />
        </F0Box>
        <F0Box width="full" padding="xl">
          <Outlet />
        </F0Box>
      </F0Box>
    </ResponsivePage.Body>
  )
}

export default RootPage
